import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../request.js";
import { constant as i } from "../../core/arrayUtils.js";
import e from "../../core/Error.js";
import { clone as a } from "../../core/lang.js";

var l = /*#__PURE__*/function () {
  function l() {
    _classCallCheck(this, l);

    this.location = {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }, this._allAvailability = "unknown", this.byteSize = 40;
  }

  _createClass(l, [{
    key: "getAvailability",
    value: function getAvailability(t, i) {
      if ("unknown" !== this._allAvailability) return this._allAvailability;

      var e = (t - this.location.top) * this.location.width + (i - this.location.left),
          a = e % 8,
          _l = e >> 3,
          o = this._tileAvailabilityBitSet;

      return _l < 0 || _l > o.length ? "unknown" : o[_l] & 1 << a ? "available" : "unavailable";
    }
  }, {
    key: "_updateFromData",
    value: function _updateFromData(t) {
      var i = this.location.width,
          e = this.location.height;

      var a = !0,
          _l2 = !0;

      var o = Math.ceil(i * e / 8),
          n = new Uint8Array(o);
      var r = 0;

      for (var s = 0; s < t.length; s++) {
        var _i = s % 8;

        t[s] ? (_l2 = !1, n[r] |= 1 << _i) : a = !1, 7 === _i && ++r;
      }

      _l2 ? this._allAvailability = "unavailable" : a ? this._allAvailability = "available" : (this._allAvailability = "unknown", this._tileAvailabilityBitSet = n, this.byteSize += n.length);
    }
  }], [{
    key: "fromDefinition",
    value: function fromDefinition(a, o) {
      var r = a.service.request || t,
          s = a.row,
          h = a.col,
          c = a.width,
          m = a.height,
          d = {
        query: {
          f: "json"
        }
      };
      return o = o ? _objectSpread(_objectSpread({}, d), o) : d, r(n(a), o).then(function (t) {
        return t.data;
      }).catch(function (t) {
        if (t && t.details && 422 === t.details.httpStatus) return {
          location: {
            top: s,
            left: h,
            width: c,
            height: m
          },
          valid: !0,
          data: i(c * m, 0)
        };
        throw t;
      }).then(function (t) {
        if (t.location && (t.location.top !== s || t.location.left !== h || t.location.width !== c || t.location.height !== m)) throw new e("tilemap:location-mismatch", "Tilemap response for different location than requested", {
          response: t,
          definition: {
            top: s,
            left: h,
            width: c,
            height: m
          }
        });
        return l.fromJSON(t);
      });
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      l.validateJSON(t);
      var i = new l();
      return i.location = Object.freeze(a(t.location)), i._updateFromData(t.data), Object.freeze(i);
    }
  }, {
    key: "validateJSON",
    value: function validateJSON(t) {
      if (!t || !t.location) throw new e("tilemap:missing-location", "Location missing from tilemap response");
      if (!1 === t.valid) throw new e("tilemap:invalid", "Tilemap response was marked as invalid");
      if (!t.data) throw new e("tilemap:missing-data", "Data missing from tilemap response");
      if (!Array.isArray(t.data)) throw new e("tilemap:data-mismatch", "Data must be an array of numbers");
      if (t.data.length !== t.location.width * t.location.height) throw new e("tilemap:data-mismatch", "Number of data items does not match width/height of tilemap");
    }
  }]);

  return l;
}();

function o(t) {
  return "".concat(t.level, "/").concat(t.row, "/").concat(t.col, "/").concat(t.width, "/").concat(t.height);
}

function n(t) {
  var i;
  if ("vector-tile" === t.service.type) i = "".concat(t.service.url, "/tilemap/").concat(t.level, "/").concat(t.row, "/").concat(t.col, "/").concat(t.width, "/").concat(t.height);else {
    var _e = t.service.tileServers;
    i = "".concat(_e && _e.length ? _e[t.row % _e.length] : t.service.url, "/tilemap/").concat(t.level, "/").concat(t.row, "/").concat(t.col, "/").concat(t.width, "/").concat(t.height);
  }
  var e = t.service.query;
  return e && (i = "".concat(i, "?").concat(e)), i;
}

export { l as Tilemap, l as default, o as tilemapDefinitionId };